import type { Tutorial } from './types';
import type { Page } from './types';

export const DYB_INTERSTITIAL_MAX_TIMES_SHOWN = 4;

/**
 * Transforms tutorial data into page data format for the interstitial
 */
export const getPagesData = (tutorial: Tutorial | null | undefined): Page[] => {
    if (!tutorial) {
        return [];
    }

    const introductionPageData: Page = {
        IMAGE: '',
        TITLE: tutorial?.title || null,
        DESCRIPTION: tutorial?.description || null,
        LABEL: null
    };

    const tutorialItems = tutorial?.items ?? [];
    const tutorialPagesData: Page[] = tutorialItems.map((page) => ({
        IMAGE: page?.asset?.url || null,
        TITLE: page?.title || null,
        DESCRIPTION: page?.text || null,
        LABEL: page?.label || null
    }));

    const pages: Page[] = [introductionPageData, ...tutorialPagesData];

    return pages;
};
